const hardSkills = [
  { name: "HTML" },
  { name: "CSS" },
  { name: "JAVASCRIPT" },
  { name: "REACT" },
  { name: "NEXT JS" },
  { name: "GIT" },
  { name: "FIGMA" },
  { name: "RWD" },
  { name: "REST API" },
  { name: "GRAPH QL" },
  { name: "TAILWIND CSS" },
  { name: "STYLED-COMPONENTS" },
];

const softSkills = [
  { name: "dokladnosc" },
  { name: "kreatywnosc" },
  { name: "komunikatywnosc" },
  { name: "zarzadzanie_czasem" },
  { name: "zarzadzanie_stresem" },
];

const projects = [
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1672684384/Personal%20site/ecommerce-hero_enee4p.jpg",
    imgAlt: "Ecommerce",
    projectDesc: "ecommerce_desc",
    projectLink: "https://bb-ecommerce.netlify.app",
    projectRepo: "https://github.com/BlazejBatko/scandiweb-junior-react-task"
  },
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352725/Personal%20site/ekolandia_f05zer.jpg",
    imgAlt: "Ekolandia",
    projectDesc: "ekolandia_desc",
    projectLink: "https://ekolandiakaszuby.pl",
  },
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352728/Personal%20site/wokaz_tej2bn.jpg",
    imgAlt: "Wo-Kaz",
    projectDesc: "wokaz_desc",
    projectLink: "https://wo-kaz.pl",
  },
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352725/Personal%20site/quizzical_evdc1d.jpg",
    imgAlt: "Quizzical",
    projectDesc: "quizzcal_desc",
    projectLink: "https://bb-quizzical.netlify.app",
    projectRepo: "https://github.com/BlazejBatko/quizzical"
 
  },
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352724/Personal%20site/capture_aeii3v.jpg",
    imgAlt: "Capture",
    projectDesc: "capture_desc",
    projectLink: "https://bb-portfolio-anim.netlify.app",
    projectRepo: "https://github.com/BlazejBatko/bb-capture"
  
  },
  {
    cdnImgLink:
      "https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352724/Personal%20site/player_jtq4nk.jpg",
    imgAlt: "Player",
    projectDesc: "player_desc",
    projectLink: "https://bb-player.netlify.app",
    projectRepo: "https://github.com/BlazejBatko/react-player"
  },
];

export { hardSkills, softSkills, projects };
